import { useAuthStore } from '@/modules/Login/store/auth.store';

export const useIsAuthenticated = () => useAuthStore(state => Boolean(state.accessToken));
